import { useRef, useState } from "react";
import { faPlay, faPause } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import audioSample from "../assets/audio/audio_sample.mp3";

const InlineAudioPlayer = () => {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const handleToggleAudio = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (audioRef.current) {
            if (isPlaying) {
                audioRef.current.pause();
                setIsPlaying(false);
            } else {
                audioRef.current.play();
                setIsPlaying(true);
            }
        }
    };

    const handleAudioEnded = () => {
        setIsPlaying(false);
    };

    return (
        <span
            onClick={handleToggleAudio}
            style={{
                cursor: "pointer",
                color: "var(--metro-yellow)",
                fontWeight: "bold",
                marginLeft: "5px"
            }}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => {
                if (e.key === "Enter") handleToggleAudio(e);
            }}
        >
            <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} className="me-1" />
            {isPlaying ? "Pause" : "Audio Sample"}
            <audio
                ref={audioRef}
                src={audioSample}
                preload="auto"
                onEnded={handleAudioEnded}
                className="d-none"
            />
        </span>
    );
};

export default InlineAudioPlayer;
